"use strict";
const emailCodeSelector = '.js-email_code_fieldset';
// inspired from https://codepen.io/RobertAron/pen/gOLLXLo and https://codepen.io/tatthien/pen/LYZxEmv
window.up.compiler(emailCodeSelector, fieldset => {
    const digitInputs = fieldset.querySelectorAll('input');
    digitInputs.forEach((digitInput, index) => {
        // moving with arrow keys or backspace
        window.up.on(digitInput, 'keydown', undefined, (e) => {
            var _a, _b, _c, _d, _e, _f;
            if (e.key === 'Backspace' && digitInput.value === '') {
                (_a = digitInputs[index - 1]) === null || _a === void 0 ? void 0 : _a.focus();
                (_b = digitInputs[index - 1]) === null || _b === void 0 ? void 0 : _b.select();
            }
            else if (e.key === 'ArrowLeft') {
                e.preventDefault();
                (_c = digitInputs[index - 1]) === null || _c === void 0 ? void 0 : _c.focus();
                (_d = digitInputs[index - 1]) === null || _d === void 0 ? void 0 : _d.select();
            }
            else if (e.key === 'ArrowRight') {
                e.preventDefault();
                (_e = digitInputs[index + 1]) === null || _e === void 0 ? void 0 : _e.focus();
                (_f = digitInputs[index + 1]) === null || _f === void 0 ? void 0 : _f.select();
            }
        });
        // on input (possibly a paste), spread the letters one per field
        window.up.on(digitInput, 'input', undefined, (e) => {
            const letters = e.target.value
                .replace(/\s/g, '')
                .split('')
                .slice(0, digitInputs.length - index);
            letters.forEach((letter, letterIndex) => {
                var _a;
                const input = digitInputs[index + letterIndex];
                if (input) {
                    input.value = letter;
                    (_a = digitInputs[index + letterIndex + 1]) === null || _a === void 0 ? void 0 : _a.focus();
                }
            });
        });
    });
});
